/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-07-30 09:58.
 */
const BaseCategoryPage = require( 'base/category-page' );
const Server = require( 'helper/server' );
const { initMenu } = require( 'purchasing-federation/common/config/member-center-menu' );

const invoiceListTpl = Handlebars.templates[ 'templates/invoice-information-list-tpl' ];

class InvoiceInformation extends BaseCategoryPage {
  constructor() {
    super();
    this.pageSize = 15;
  }

  async init() {
    const data = initMenu( 'InvoiceInformation', {}, {} );
    this.$el.find( '.list__nav-title' ).html( data.text );
    this.$el.find( '.treeData[name="tree-data"]' ).html( JSON.stringify( data ) );
    super.init();
  }

  search() {
    const requestParams = {
      pageNo: this.pageNo,
      pageSize: this.pageSize
    };
    this.renderInfoList( requestParams );
  }

  async renderInfoList( requestParams ) {
    const spiner = this.$el.find( '.block__content' ).spin();
    const { data = [], total = 0 } = await Server.getInvoice( requestParams );
    this.$content.find( '.block__content' ).html( invoiceListTpl( {
      _DATA_: data,
      _pageSize_: this.pageSize
    } ) );
    this.$el.find( '.block__content .total' ).text( total || 0 );
    this.initPagination( total );
    spiner.stop();
  }
}

module.exports = InvoiceInformation;
